import { render, staticRenderFns } from "./LinkDetailsDialog.vue?vue&type=template&id=66868bef&scoped=true&"
import script from "./LinkDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./LinkDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./LinkDetailsDialog.vue?vue&type=style&index=0&id=66868bef&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66868bef",
  null
  
)

export default component.exports